import { AppWindow, Button } from "@repo/ui";
import { RowButton } from "~/components/ui/row-button";

type Props = {
  id: number;
  label: string;
  isActive: boolean;
  onItemClick: (itemId: number, itemName: string) => void;
  onOpenInNewWindow: (itemId: number) => void;
};

export const ListsRow = ({ id, label, isActive, onItemClick, onOpenInNewWindow }: Props) => {
  return (
    <div className="flex w-full items-center">
      <div className="mr-2">
        <Button
          data-allow-navigation
          variant="primary"
          size="icon_sm"
          icon={<AppWindow className="h-3.5 w-3.5" />}
          onClick={() => onOpenInNewWindow(id)}
          title="Open in new window"
        />
      </div>
      <RowButton
        data-allow-navigation
        id={id}
        size="sm"
        label={label}
        customDesignLogic={isActive ? "border-blue-500 bg-blue-100" : ""}
        customTextDesignLogic={isActive ? "italic" : ""}
        onRowItemClick={() => onItemClick(id, label)}
      />
    </div>
  );
};
